"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var merge_1 = __importDefault(require("lodash/merge"));

var variables_1 = require("../variables");

var defaultTheme_1 = require("./defaultTheme"); // TODO would be good for consistency to append Color (or .color) behind each prop that is a color


exports.lightTheme = merge_1["default"]({}, defaultTheme_1.defaultTheme, {
  global: {
    backgroundColor: variables_1.colors.white,
    errorColor: variables_1.colors.red,
    disabledColor: variables_1.colors.grey
  },
  textStyles: {
    textBody: {
      color: variables_1.colors.anthrazit
    },
    heading: {
      color: variables_1.colors.black
    },
    textHelper: {
      color: variables_1.colors.darkgrey
    }
  },
  link: {
    border: variables_1.colors.grey,
    normal: variables_1.colors.anthrazit,
    hover: variables_1.colors.black,
    active: variables_1.colors.black
  },
  imageTile: {
    textColor: variables_1.colors.white
  },
  button: {
    secondary: {
      textColor: variables_1.colors.anthrazit,
      hover: {
        textColor: variables_1.colors.black
      },
      active: {
        textColor: variables_1.colors.black
      }
    },
    disabled: {
      textColor: variables_1.colors.grey,
      borderColor: variables_1.colors.grey
    }
  },
  tabGroup: {
    label: {
      defaultColor: variables_1.colors.darkgrey,
      selectedColor: variables_1.colors.black,
      hoverColor: variables_1.colors.black,
      defaultBorderColor: variables_1.colors.grey
    }
  },
  table: {
    hoverColor: variables_1.colors.lightgrey,
    tbody: {
      borderColor: variables_1.colors.lightgrey
    }
  },
  circleDiagram: {
    circle: variables_1.colors.lightgrey
  },
  separator: {
    color: variables_1.colors.lightgrey
  },
  accordion: {
    hoverBackgroundColor: variables_1.colors.whiteGray,
    borderColor: variables_1.colors.lightgrey
  },
  form: {
    placeholderColor: variables_1.colors.darkgrey,
    activeTextColor: variables_1.colors.black,
    tankDefaultColor: variables_1.colors.grey,
    tankHoverColor: variables_1.colors.anthrazit,
    box: {
      borderColor: variables_1.colors.darkgrey,
      disabled: {
        labelColor: variables_1.colors.darkgrey
      }
    },
    dropdown: {
      arrowColor: variables_1.colors.darkgrey
    },
    rangeSlider: {
      knobColor: variables_1.colors.lightAnthracite,
      trackColor: variables_1.colors.lightgrey,
      largeLabel: variables_1.colors.grey
    }
  },
  menuItem: {
    color: variables_1.colors.anthrazit
  },
  withLoading: {
    overlay: {
      backgroundColor: "rgba(255, 255, 255, 0.85)"
    }
  },
  titleContent: {
    labelColor: variables_1.colors.darkgrey
  },
  stickyHeader: {
    borderColor: variables_1.colors.lightgrey
  },
  carousel: {
    button: {
      backgroundColor: variables_1.colors.lightgrey
    },
    item: {
      backgroundColor: variables_1.colors.grey
    }
  }
});